/*!
 * Stimpack Control - Content Block
 *
 * @version : 1.0
 */

import { spIsBase64, spBase64Encode, spBase64Decode } from '../utilities/utilities';

(function($) {

    var spControlContentBlock = function(root, options)
    {
        var _this = this,
            root = $(root);

        this.options = $.extend({
            name            : '',
            multiple        : false,
            itemTemplate    : '',
            selectors       : {
                encodedOutput  : '.sp-control-content-block-encoded-output'
            }
        }, options);

        this.el = {
            root            : root,
            itemList        : root.find('.sp-control-content-block-items'),
            addButton       : root.find('.sp-control-content-block-add'),
            encodedOutput   : root.find(this.options.selectors.encodedOutput)
        };

        this.init();
    };

    /*
     * Init
     */
    spControlContentBlock.prototype.init = function()
    {
        var _this = this;

        this.el.root.on('change', '.sp-control-content-block-item-id', function() {

            var item = $(this).closest('.sp-control-content-block-item');

            if ($(this).find('[value="custom"]').is(':selected'))
            {
                item.addClass('sp-control-content-block-item-custom-selected');
            }
            else
            {
                item.removeClass('sp-control-content-block-item-custom-selected');
            }

            _this.refresh();
        });

        this.el.root.on('change', '.sp-control-content-block-item-content textarea', function() {
            _this.refresh();
        });


        this.el.addButton.on('click', function() {
            _this.addItem();
        });

        this.el.root.on('click', '.sp-control-content-block-item-remove', function() {
            _this.removeItem($(this).closest('.sp-control-content-block-item'));
        });

        this.el.root.on('click', '.sp-control-content-block-item-move-down', function() {
            _this.moveItemDown($(this).closest('.sp-control-content-block-item'));
        });

        this.el.root.on('click', '.sp-control-content-block-item-move-up', function() {
            _this.moveItemUp($(this).closest('.sp-control-content-block-item'));
        });
    }


    /*
     * Get value
     */
    spControlContentBlock.prototype.getValue = function()
    {
        var json = this.el.root.find('[name' + (this.options.name ? '*="' + this.options.name + '"' : '') + ']:not(' + this.options.selectors.encodedOutput + ')').serializeJSON({useIntKeysAsArrayIndex: false});

        if (typeof json === 'object')
        {
            if (typeof json[this.options.name] === 'object')
            {
                json = json[this.options.name];
            }
            else if (typeof json.acf === 'object')
            {
                json = json.acf;
                json = json[Object.keys(json)[0]];
            }

            return json;
        }
    };

    /*
     * Refresh item custom value
     */
    spControlContentBlock.prototype.getItemCustomTextareaValue = function(item)
    {
        var control = item.find('.CodeMirror') || item.find('.sp-control-content-block-item-content');

        if (typeof control[0]['CodeMirror'] === 'object')
        {
            return control[0]['CodeMirror'].getValue();
        }

        return control.val();
    }


    /*
     * Refresh
     */
    spControlContentBlock.prototype.refresh = function()
    {
        this.refreshItemIndexes();
        this.updateEncodedOutput();
    }


    /*
     * Add item
     */
    spControlContentBlock.prototype.addItem = function()
    {
        var newItem = $(this.options['itemTemplate']);

        newItem.find('[data-sp-control-select]').each(function() {
            $(this).spControlSelect();
        });

        this.el.itemList.append(newItem);

        setTimeout(function() {
            newItem.find('[data-sp-control-text-editor]').each(function() {
                $(this).spControlTextEditor();
            });
        }, 500);

        this.refresh();
    }

    /*
     * Remove item
     */
    spControlContentBlock.prototype.removeItem = function(item)
    {
        item.remove();
        this.refresh();
    }

    /*
     * Move item down
     */
    spControlContentBlock.prototype.moveItemDown = function(item)
    {
        var nextItem = item.next();

        if (nextItem.length < 1)
        {
            return false;
        }

        item.next().after(item);
        this.refresh();
    }


    /*
     * Move item up
     */
    spControlContentBlock.prototype.moveItemUp = function(item)
    {
        var prevItem = item.prev();

        if (prevItem.length < 1)
        {
            return false;
        }

        item.prev().before(item);
        this.refresh();
    }

    /*
     * Refresh item indexes
     */
    spControlContentBlock.prototype.refreshItemIndexes = function()
    {
        this.el.itemList.find('.sp-control-content-block-item').each(function(index) {

            $(this).find('[name]').each(function() {
                var name = $(this).attr('name');
                $(this).attr('name', name.replace(/\[[0-9]+\]/, '[' + index + ']'));
            });
        });
    }

    /*
     * Update json output
     */
    spControlContentBlock.prototype.updateEncodedOutput = function()
    {
        if (this.el.encodedOutput.length > 0)
        {
            var value = this.getValue();

            if (value)
            {
                $.each(value, function(i, item) {

                    if (!item.id && !item.content)
                    {
                        delete value[i];
                    }
                });
            }

            if (!$.isEmptyObject(value))
            {
                this.el.encodedOutput.val(spBase64Encode(JSON.stringify(value)));
            }
            else
            {
                this.el.encodedOutput.val('');
            }
        }
    }


    $.fn.spControlContentBlock = function(options)
    {
        options = options || {};

        return this.each(function() {

            var _options = $(this).data('sp-control-content-block');

            $(this).attr('data-sp-control-content-block', true);

            if (_options)
            {
                if (typeof _options == 'object')
                {
                    options = $.extend({}, options, _options);
                }
                else if (spIsBase64(_options))
                {
                    options = $.extend({}, options, _options ? JSON.parse(spBase64Decode(_options)) : {});
                }
            }

            this.spControlContentBlock = new spControlContentBlock(this, options);
        });
    };

    // Declaration
    $('[data-sp-control-content-block]').each(function() {
        $(this).spControlContentBlock();
    });

})(jQuery);
